import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import EditableField from './EditableField';
import {FormControl, FormGroup, HelpBlock} from 'react-bootstrap';
import validator from 'validator';

class EditableAction extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      text: props.value || '',
      editing: false,
      error: '',
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.editing && this.state.text !== this.props.value) {
      this.setState({ text: this.props.value });
    }
  }

  toggleEdit = (editing) => {
    if (!editing && validator.isEmpty(this.state.text)) {
      this.setState({error: 'Required field'});
    } else {
      this.setState(prevState => {
        if (prevState.editing) {
          this.props.onSubmit(prevState.text);
        }
        return {
          editing: !prevState.editing,
          error: ''
        };
      });
    }
  };

  onChange = (event) => {
    const target = event.target;
    this.setState({text: target.value});
  };

  render() {
    return (
      <EditableField
        value={<ItemText>{this.state.text}</ItemText>}
        editing={this.state.editing}
        onToggle={this.toggleEdit}
      >
        <FormGroup className={'mb0'} validationState={this.state.error ? 'error' : null}>
          <FormControl style={{width: '30rem', maxWidth: '30rem'}} value={this.state.text || ''} onChange={this.onChange} componentClass='textarea'/>
          { this.state.error && <HelpBlock style={{ fontSize: '10px' }}>{this.state.error}</HelpBlock> }
        </FormGroup>
      </EditableField>
    );
  }
}

const ItemText = styled.span`
   word-wrap: break-word;
   white-space: normal;
   word-break: break-all;
   max-width: 30rem;
`;

EditableAction.propTypes = {
  value: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default EditableAction;


// WEBPACK FOOTER //
// ./src/components/engagement/EditableAction.js